import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Paper, Typography } from "@mui/material";
import useMode from "hooks/useMode";

const UniqueVisitorChart = ({ data, title }) => {
  const mode = useMode()

  return (
    <>
      <Paper sx={{ p: 2, backgroundColor: mode.third }}>
        <Typography variant="h6" gutterBottom>
          {title ?? ''}
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={data}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Area min={50} type="monotone" dataKey="成約物件" stroke="#f0ad4e" fill="#f0ad4e" />
            <Area min={50} type="monotone" dataKey="SUUMOの掲載中物件" stroke="#1da1f2" fill="#1da1f2" />
            <Area
              type="monotone"
              dataKey="先月残掲載物件"
              stroke="#8884d8"
              fill="#8884d8"
            />

            <Area
              type="monotone"
              min={50}
              values="50"
              dataKey="新着物件"
              stroke="#82ca9d"
              fill="#82ca9d"
            />
          </AreaChart>
        </ResponsiveContainer>

      </Paper>

      {/* {quantity && <Card sx={{ borderTop: '2px solid #1076BB', px: 3, py: 5, mt: 3 }}> <Typography color={'red'} variant="h6" gutterBottom>
        {quantity ?? ''}
      </Typography> </Card>} */}
    </>
  )
};
export default UniqueVisitorChart;
